import axios from 'axios';

const evalRunsEndpoint = '/api/eval-runs';
const tagsEndpoint = '/api/tags';
const exploreEndpoint = '/api/explore';

export const fetchTopLlmsPerIndustryLeaderboard = async () => {
    try {
        const response = await axios.get(`${evalRunsEndpoint}/top-llms-industry-leaderboard`);
        return response.data;
    } catch (error) {
        console.error('Error fetching top LLMs per industry:', error);
        return [];
    }
}

export const fetchEvalTagsWithLeaderboard = async () => {
    console.log('fetching eval tags with leaderboard');
    try {
        const response = await axios.get(`${tagsEndpoint}/eval-tags?hasLeaderboard=true`);
        return response.data;
    } catch (error) {
        console.error('Error fetching eval tags with leaderboard:', error);
        return [];
    }
}

export const fetchEvalRunsAverageLeaderboard = async (tagId = null, typeId = null) => {
    try {
        const params = {}
        if (tagId) {
            params.tag_id = tagId;
        }
        if (typeId) {
            params.type_id = typeId;
        }
        const response = await axios.get(`${evalRunsEndpoint}/average-leaderboard`, { params });
        return response.data;
    } catch (error) {
        console.error('Error fetching eval runs average leaderboard:', error);
        return [];
    }
}

export const fetchLlms = async () => {
    try {
        const response = await axios.get(`${exploreEndpoint}/filter/llms`);
        return response.data;
    } catch (error) {
        console.error('Error fetching LLMs:', error);
        return [];
    }
}